import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Language } from '../../models/language.model';
import { FormsModule } from '@angular/forms';
import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SupportedLanguage } from '../../models/supported-language.model';

@Component({
  selector: 'app-languages-switcher',
  imports: [FormsModule, TranslateModule],
  templateUrl: './languages-switcher.component.html',
  styleUrl: './languages-switcher.component.scss',
})
export class LanguagesSwitcherComponent implements OnInit, OnDestroy {
  public translateService: TranslateService = inject(TranslateService);
  public currentLanguage: string = '';
  private langChangeSubscription?: Subscription;
  languages: Language[] = [
    {
      id: 13,
      name: this.translateService.instant('languages.french'),
      short: 'fr-FR',
      flag_code: 'FR',
    },
    {
      id: 14,
      name: this.translateService.instant('languages.english'),
      short: 'en-EN',
      flag_code: 'GB',
    },
    {
      id: 15,
      name: this.translateService.instant('languages.spanish'),
      short: 'es-ES',
      flag_code: 'ES',
    },
    {
      id: 16,
      name: this.translateService.instant('languages.german'),
      short: 'de-DE',
      flag_code: 'DE',
    },
    {
      id: 17,
      name: this.translateService.instant('languages.italian'),
      short: 'it-IT',
      flag_code: 'IT',
    },
  ];

  switchLanguage(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const languageCode: string = target.value;
    if (languageCode as SupportedLanguage) {
      this.translateService.use(languageCode);
      this.currentLanguage = languageCode;
      localStorage.setItem('language', languageCode);
    } else {
      console.error('Langue non supportée:', languageCode);
    }
  }

  ngOnInit(): void {
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event) => {
        this.currentLanguage = event.lang;
      }
    );

    setTimeout(() => {
      this.currentLanguage =
        this.translateService.currentLang ||
        this.translateService.getDefaultLang();
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
